import "/builds/extern/aware7-web/packages/web/src/lib/sentry-client-noop.ts";
import { init } from 'astro/virtual-modules/prefetch.js';init()